import { Background } from "@bonusx-global/bx-design-system";
import { lazyWithRecovery } from "../../lib/chunk-load-recovery/lazy-with-recovery";
import type { RouteObject } from "react-router-dom";
import { createAbacLoader } from "../../app/router/guards/loaders/abac.loader";
import { BaseLayout } from "../../components/layouts/BaseLayout";
import DefaultLayout from "../../components/layouts/default-layout/DefaultLayout";
import RouteWrapper from "../../components/layouts/route-wrapper/RouteWrapper";
import { REQUESTED_SERVICES_PATH } from "../../constants/env";
import CloseChatbotPanelWrapper from "../../legacy/components/Chatbot/wrappers/close-chatbot-panel-wrapper/close-chatbot-panel-wrapper";
import CompletedProcedurePageHeader from "../../legacy/components/HeaderV2/page-adapters/completed-procedure-page/completed-procedure-page-header";
import ProcedurePageHeader from "../../legacy/components/HeaderV2/page-adapters/procedure-page/procedure-page-header";
import SEO from "../../legacy/components/Seo";
import { BonusXThemeProvider } from "../../legacy/theme/BonusXThemeProvider";
import { withSuspense } from "./utils/with-suspense";

const RequestedServicesPage = lazyWithRecovery(
  () => import("../../app/pages/RequestedServicesPage/RequestedServicesPage")
);
const RequestedServiceSinglePage = lazyWithRecovery(
  () => import("../../legacy/pages/ServiceRequest/SingleServiceRequest/SingleServiceRequestPage")
);

export function createRequestedServicesRoutes(): RouteObject[] {
  return [
    // Requested services list
    {
      path: REQUESTED_SERVICES_PATH,
      loader: createAbacLoader({ permission: { can: "readAll", model: "ServiceRequest" } }),
      element: (
        <DefaultLayout>
          <SEO title="Pratiche" />
          <RouteWrapper>{withSuspense(<RequestedServicesPage />)}</RouteWrapper>
        </DefaultLayout>
      ),
    },

    // Requested service single page
    {
      path: "/requested-services/:id",
      loader: createAbacLoader({ permission: { can: "readOne", model: "ServiceRequest" } }),
      element: (
        <BaseLayout additionalCss={{ background: Background.default }} header={<ProcedurePageHeader />}>
          <BonusXThemeProvider>
            <CloseChatbotPanelWrapper>{withSuspense(<RequestedServiceSinglePage />)}</CloseChatbotPanelWrapper>
          </BonusXThemeProvider>
        </BaseLayout>
      ),
    },

    // Requested service completed
    {
      path: "/requested-services/:id/completed",
      loader: createAbacLoader({ permission: { can: "readOne", model: "ServiceRequest" } }),
      element: (
        <>
          <SEO title="Pratiche" />
          <BaseLayout additionalCss={{ background: Background.default }} header={<CompletedProcedurePageHeader />}>
            <BonusXThemeProvider>
              <CloseChatbotPanelWrapper>{withSuspense(<RequestedServiceSinglePage />)}</CloseChatbotPanelWrapper>
            </BonusXThemeProvider>
          </BaseLayout>
        </>
      ),
    },
  ];
}
